import { render } from "./RibaHistory.vue?vue&type=template&id=11c8fd86"
import script from "./RibaHistory.vue?vue&type=script&lang=js"
export * from "./RibaHistory.vue?vue&type=script&lang=js"
script.render = render

export default script